import React from 'react';

const TripLogIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 14C5.26667 14 4.63889 13.7389 4.11667 13.2167C3.59444 12.6944 3.33333 12.0667 3.33333 11.3333V5.88333C2.94444 5.73889 2.62511 5.49733 2.37533 5.15867C2.12556 4.82 2.00044 4.43378 2 4C2 3.44444 2.19444 2.97222 2.58333 2.58333C2.97222 2.19444 3.44444 2 4 2C4.55556 2 5.02778 2.19444 5.41667 2.58333C5.80556 2.97222 6 3.44444 6 4C6 4.43333 5.87511 4.81956 5.62533 5.15867C5.37556 5.49778 5.056 5.73933 4.66667 5.88333V11.3333C4.66667 11.7 4.79733 12.014 5.05867 12.2753C5.32 12.5367 5.63378 12.6671 6 12.6667C6.36622 12.6662 6.68022 12.5358 6.942 12.2753C7.20378 12.0149 7.33422 11.7009 7.33333 11.3333V4.66667C7.33333 3.93333 7.59444 3.30556 8.11667 2.78333C8.63889 2.26111 9.26667 2 10 2C10.7333 2 11.3611 2.26111 11.8833 2.78333C12.4056 3.30556 12.6667 3.93333 12.6667 4.66667V10.1167C13.0556 10.2611 13.3751 10.5029 13.6253 10.842C13.8756 11.1811 14.0004 11.5671 14 12C14 12.5556 13.8056 13.0278 13.4167 13.4167C13.0278 13.8056 12.5556 14 12 14C11.4444 14 10.9722 13.8056 10.5833 13.4167C10.1944 13.0278 10 12.5556 10 12C10 11.5667 10.1251 11.1778 10.3753 10.8333C10.6256 10.4889 10.9449 10.25 11.3333 10.1167V4.66667C11.3333 4.3 11.2029 3.98622 10.942 3.72533C10.6811 3.46444 10.3671 3.33378 10 3.33333C9.63289 3.33289 9.31911 3.46356 9.05867 3.72533C8.79822 3.98711 8.66756 4.30089 8.66667 4.66667V11.3333C8.66667 12.0667 8.40556 12.6944 7.88333 13.2167C7.36111 13.7389 6.73333 14 6 14Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default TripLogIcon;
